import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, selecionarEmpresa, salvarSessao } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { APP_VERSION } from '../version';
import logo from '../logo-genpac.png';
import './Login.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro,  setErro]  = useState('');
  const [load,  setLoad]  = useState(false);

  // Seleção de empresa (multi-empresa)
  const [selecao, setSelecao] = useState(null); // { user_token, empresas }
  const [loadSel, setLoadSel] = useState(false);

  const { entrar } = useAuth();
  const navigate   = useNavigate();

  // ─── Step 1: autenticar ────────────────────────────────────────────────────

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro(''); setLoad(true);
    try {
      const data = await login(email.trim(), senha);

      if (data.requires_company_selection) {
        // Múltiplas empresas → exibe seletor
        setSelecao({ user_token: data.user_token, empresas: data.empresas });
      } else {
        // Empresa única → login direto
        salvarSessao(data.access_token, data.nome, data.empresa, data.is_admin, data.empresa_id, data.empresas);
        entrar(data.nome, data.empresa, data.is_admin, data.empresa_id, data.empresas);
        navigate('/dashboard');
      }
    } catch (err) {
      setErro(err.message || 'E-mail ou senha inválidos.');
    } finally {
      setLoad(false);
    }
  };

  // ─── Step 2: selecionar empresa ────────────────────────────────────────────

  const handleSelecionarEmpresa = async (empresaId) => {
    setLoadSel(true); setErro('');
    try {
      const data = await selecionarEmpresa(selecao.user_token, empresaId);
      entrar(data.nome, data.empresa, data.is_admin, data.empresa_id, data.empresas);
      navigate('/dashboard');
    } catch (err) {
      setErro(err.message || 'Erro ao selecionar empresa.');
    } finally {
      setLoadSel(false);
    }
  };

  const voltarLogin = () => { setSelecao(null); setErro(''); };

  // ─── Render: seletor de empresa ────────────────────────────────────────────

  if (selecao) {
    return (
      <div className="login-bg">
        <div className="login-deco login-deco-1" />
        <div className="login-deco login-deco-2" />
        <div className="login-card fade-in">
          <div className="login-logo-area">
            <img src={logo} alt="Genpac" className="login-logo-img" />
            <div>
              <div className="login-logo-nome">arauto<span className="login-logo-360">360</span></div>
              <div className="login-logo-sub">ERP Cloud</div>
            </div>
          </div>

          <h1 className="login-titulo">Selecione a empresa</h1>
          <p className="login-desc">Você possui acesso a múltiplas empresas.</p>

          <div className="login-empresas">
            {selecao.empresas.map(emp => (
              <button
                key={emp.id}
                className="login-empresa-btn"
                disabled={loadSel}
                onClick={() => handleSelecionarEmpresa(emp.id)}
              >
                <span className="login-empresa-icon"><IcoBuild /></span>
                <span className="login-empresa-nome">{emp.nome}</span>
                <span className="login-empresa-arrow">›</span>
              </button>
            ))}
          </div>

          {erro && <div className="login-erro">⚠ {erro}</div>}

          <button className="login-voltar" onClick={voltarLogin} disabled={loadSel}>
            ← Voltar ao login
          </button>

          <p className="login-footer">arauto360 © {new Date().getFullYear()} · v{APP_VERSION}</p>
        </div>
      </div>
    );
  }

  // ─── Render: formulário de login ───────────────────────────────────────────

  return (
    <div className="login-bg">
      <div className="login-deco login-deco-1" />
      <div className="login-deco login-deco-2" />
      <div className="login-card fade-in">
        <div className="login-logo-area">
          <img src={logo} alt="Genpac" className="login-logo-img" />
          <div>
            <div className="login-logo-nome">arauto<span className="login-logo-360">360</span></div>
            <div className="login-logo-sub">ERP Cloud</div>
          </div>
        </div>
        <h1 className="login-titulo">Bem-vindo de volta</h1>
        <p className="login-desc">Acesse com suas credenciais</p>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="lf-group">
            <label htmlFor="login-email">E-mail</label>
            <input
              id="login-email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="seu@email.com"
              required
              autoFocus
              autoComplete="email"
              inputMode="email"
            />
          </div>
          <div className="lf-group">
            <label htmlFor="login-senha">Senha</label>
            <input
              id="login-senha"
              type="password"
              value={senha}
              onChange={e => setSenha(e.target.value)}
              placeholder="••••••••"
              required
              autoComplete="current-password"
            />
          </div>
          {erro && <div className="login-erro">⚠ {erro}</div>}
          <button className="login-btn" type="submit" disabled={load}>
            {load ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
        <p className="login-footer">arauto360 © {new Date().getFullYear()}</p>
      </div>
    </div>
  );
}

function IcoBuild() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
      <polyline points="9 22 9 12 15 12 15 22"/>
    </svg>
  );
}
